var map = {
	"./bh-ico.svg": 1896,
	"./bonus-ico.svg": 1897,
	"./deposit-ico.svg": 1898,
	"./edit-icon.svg": 1899,
	"./fb-ico.svg": 1900,
	"./mall-ico.svg": 1901,
	"./msg-ico.svg": 1902,
	"./pi-ico.svg": 1903,
	"./rf-ico.svg": 1904,
	"./rh-ico.svg": 1905,
	"./th-ico.svg": 1906,
	"./vip-ico.svg": 1907,
	"./withdrawal-ico.svg": 1908,
	"./wl-ico.svg": 1909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1895;